/**
 * GROQ projection for accreditation dates under familiar Sanity keys.
 * Maps CMS `publishedAt` / `updatedAt` onto `_createdAt` / `_updatedAt`
 * so consumers keep existing field names. Falls back to system timestamps
 * until backfill sets explicit fields.
 */
export const contentDateFieldsGroq = `"_createdAt": coalesce(publishedAt, _createdAt),
  "_updatedAt": coalesce(updatedAt, _updatedAt)`;

/**
 * GROQ projection for sitemap timestamps.
 * Prefer accreditation dates; fall back to Sanity system timestamps
 * (also covers document types without CMS date fields, e.g. video).
 */
export const sitemapDateFieldsGroq = `"createdAt": coalesce(publishedAt, _createdAt),
  "lastEdited": coalesce(updatedAt, _updatedAt)`;

const DATE_FORMAT: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "long",
	day: "numeric",
	timeZone: "UTC",
};

/**
 * Formats an ISO date for public content UI (accreditation-facing).
 */
export const formatContentDate = (iso: string): string =>
	new Date(iso).toLocaleDateString("en-US", DATE_FORMAT);

const toUtcDay = (iso: string): number => {
	const date = new Date(iso);
	return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

/**
 * True when `updatedAt` falls on a later UTC calendar day than `createdAt`.
 */
export const isContentUpdatedAfterPublish = (
	createdAt: string,
	updatedAt: string,
): boolean => toUtcDay(updatedAt) > toUtcDay(createdAt);
